import React, { useEffect, useRef, useState } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import apis from '../../api';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import '../../DataTableDemo.css';
import { saveAs } from 'file-saver';
import Base64Downloader from 'common-base64-downloader-react';
import Video from '../Video/Video';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import useWindowDimensions from '../hooks/useDimensions';
import './PayOrder.css'
import { Dialog } from 'primereact/dialog';
import { DataScroller } from 'primereact/datascroller';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Employes
Description : Pagina de Appointment para el CRUD de los empleados del aplicativo remunerlite.
Date Autor Modification
================================================================================
23/10/2021 Cristian Andres Pizo Mina - Pagina de Empleados
5/4/2022 Cristian Andres Pizo Mina - Comentarios
================================================================================ */

export default function PayOrder() {
  // declarar constantes
  const [payroll_payment, setPayroll_payment] = useState([]);
  const [dataEpaycoTransaction, setDataEpaycoTransaction] = useState({
    key: '',
    isTest: true,
    externalPay: false,
    currencyPay: 'cop',
    countryPay: 'co',
    languagePay: 'es',
    confirmationUrl: '',
    responseUrl: window.location.href,
    customerName: '',
    customerAddress: '',
    customerDocType: '',
    customerDoc: '',
    customerPhone: '',
  });
  const [products, setProducts] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(5);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');
  const [ePayco, setEpayco] = useState(null);
  const toast = useRef(null);
  const payStatus = {
    pending: 'PEN',
    paid: 'PAG',
    declined: 'REF',
    processing: 'PRO'
  };
  const clientID = localStorage.getItem('client');
  const clientEmail = localStorage.getItem('user');
  const [loadPage, setLoadPage] = useState(false)
  const [contenido, setContenido] = useState("")
  const { width } = useWindowDimensions()
  const headers = { authorization: localStorage.getItem('token') }
  const [isOpen, setIsOpen] = React.useState(false);
  const [loading2, setLoading2] = React.useState(false);
  const [name, setName] = useState("")
  const [description, setDescription] = useState("")
  const [rowStateFile, setRowStateFile] = useState({});

  // funcion para obtener los empleados
  useEffect(() => {
    getKeysEpayco();
    getCustomerData();
    getOrdersData();
  }, []);

  useEffect(() => {
    if (typeof window.ePayco === "undefined") {
      const script = document.createElement("script");
      script.src = "https://checkout.epayco.co/checkout.js";
      script.async = true;
      document.body.appendChild(script);

      script.onload = () => {
        setHandlerEpayco();
      }
    } else {
      setHandlerEpayco();
    }
  }, [dataEpaycoTransaction]);

  const setHandlerEpayco = () => {
    let ePayco = window.ePayco.checkout.configure({
      key: dataEpaycoTransaction.key,
      test: JSON.parse(process.env.REACT_APP_EPAYCO_FLAG) // True activa el modo test, false activa el modo producción
    });

    setEpayco(ePayco);
  }

  // mostrar modal
  const showModal = () => {
    setIsOpen(true);
  };

  // ocultar modal
  const hideModal = () => {
    setIsOpen(false);
    clearData()
  };

  const getCustomerData = () => {
    let client = {
      "CLIENT": clientID
    }
    //Llamar endpoint para obtener datos
    apis.getCustomerInformation(encodeURI(JSON.stringify(client)), {}).then(res => {
      let data = res.data
      let updateCustomerData = data;

      setDataEpaycoTransaction(dataEpaycoTransaction => ({
        ...dataEpaycoTransaction,
        ...updateCustomerData
      }));
    })
  }

  const getKeysEpayco = () => {
    /*Llamar endpoint para obtener datos*/
    apis.getEpaycoParams({}).then(res => {
      let data = res.data
      let updateEpaycoKeys = {
        key: data.PUBLIC_KEY,
        /*  confirmationUrl: data.URL, */
        confirmationUrl: data.URL,
        methodPayDisabled: data.METHOD_PAY_DISABLED
      }

      setDataEpaycoTransaction(dataEpaycoTransaction => ({
        ...dataEpaycoTransaction,
        ...updateEpaycoKeys
      }))
    })

  }

  const getOrdersData = () => {
    let orders = []
    let params = {
      "CLIENT": clientID
    }

    apis.getEpaycoTransactions(encodeURI(JSON.stringify(params)), {}).then(res => {
      let data = res.data.TRANSACTIONS;
      let statesFile = {}
      let rowCounter = 0
      data.forEach(element => {
        orders.push({
          ROW_ID: rowCounter,
          TRANSACTION_ID: element.TRANSAC_ID,
          PAYMENT_TRANSAC_ID: element.PAYMENT_TRANSAC_ID,
          ORDER_NAME: element.DESCRIPTION,
          ORDER_DESCRIPTION: element.DESCRIPTION,
          STATUS: element.STATUS,
          STATUS_HIST: element.STATUS_HIST,
          TRANSACTION_DATE: element.DATE,
          PAY_METHOD: element.PAYMENT_METHOD.DESCRIPTION,
          TOTAL_VALUE: currencyConverter(element.TOTAL_VALUE),
          NAME_INVOICE: element.NAME_INVOICE,
          PDF: (element.PDF) ? element.PDF : ''
        })
        statesFile = {
          ...statesFile,
          [rowCounter]: false
        }
        rowCounter++
      })
      setRowStateFile(statesFile)
      setProducts(orders)
      setLoadPage(true)
    })
  }

  //función para lanzar modal con formulario de pago de ePayco
  const executeEpaycoCheckout = (transacHist) => {
    let data = {
      //Parametros compra (obligatorio)
      name: transacHist.DESCRIPTION,
      description: transacHist.DESCRIPTION,
      currency: dataEpaycoTransaction.currencyPay,
      amount: transacHist.TOTAL_VALUE,
      /* amount: transacHist.TOTAL_VALUE, */
      tax_base: "0",
      tax: "0",
      country: dataEpaycoTransaction.countryPay,
      lang: dataEpaycoTransaction.languagePay,
      //Onpage="false" - Standard="true"
      external: dataEpaycoTransaction.externalPay,
      //Atributos opcionales
      confirmation: dataEpaycoTransaction.confirmationUrl,
      response: dataEpaycoTransaction.responseUrl,
      //Atributos cliente
      name_billing: dataEpaycoTransaction.customerName,
      address_billing: dataEpaycoTransaction.customerAddress,
      type_doc_billing: dataEpaycoTransaction.customerDocType,
      mobilephone_billing: dataEpaycoTransaction.customerPhone,
      number_doc_billing: dataEpaycoTransaction.customerDoc,
      //atributo deshabilitación metodo de pago
      methodsDisable: dataEpaycoTransaction.methodPayDisabled,
      extra1: transacHist.PAYMENT_TRANSAC_ID,
      extra2: transacHist.TRANSAC_HIST_ID,
      extra3: clientID,
      extra4: clientEmail
    }

    ePayco.open(data);
  }

  const saveEpaycoinitialTransaction = (rowData) => {
    let user = {
      "USER": clientEmail
    }

    let params = {
      "PAYMENT_TRANSAC_ID": rowData.PAYMENT_TRANSAC_ID,
      "CLIENT": clientID,
      "ENTITY": clientID,
      "STATUS": payStatus.processing
    }

    apis.postEpaycoTransaction(encodeURI(JSON.stringify(user)), encodeURI(JSON.stringify(params)), {}).then(res => {
      let data = res.data;
      if (data.TRANSACTIONS.length > 0) {
        executeEpaycoCheckout(data.TRANSACTIONS[0]);
      }
    })
  }

  async function generateVoucher(rowData) {
    initializeData(rowData)
    try {
      await apis.getInvoice(rowData.PAYMENT_TRANSAC_ID, headers).then(res => {
        let _contenido = "data:application/pdf;base64," + res.data.PDF.DATA
        setContenido(_contenido);
        setRowStateFile({ ...rowStateFile, [rowData.ROW_ID]: false });
        showModal()
      })
    }
    catch (err) {
      setLoading2(false)
      setRowStateFile({ ...rowStateFile, [rowData.ROW_ID]: false });
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, life: 4000 })
    }
  }

  const currencyConverter = (value) => {
    return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(value);
  }

  //Evento para cambiar de pagina
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }
  //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
          <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  //Boton realizar pago desde la tabla, en rowData se guarda el {} con todos los datos de la fila
  const actionBodyTemplate = (rowData) => {
    if (rowData.STATUS.ID !== payStatus.paid && rowData.STATUS.ID !== payStatus.processing && (rowData.STATUS.ID === payStatus.pending && (rowData.STATUS_HIST.ID !== payStatus.pending && rowData.STATUS_HIST.ID !== payStatus.processing))) {
      return <Button icon="pi pi-dollar" label="Pagar" className="p-button-success mr-2 p-button-sm text-xs" onClick={() => saveEpaycoinitialTransaction(rowData)} />
    } else {
      return <div></div>
    }
  }

  //Boton descargar factura desde la tabla, en rowData se guarda el {} con todos los datos de la fila
  const invoiceBodyTemplate = (rowData) => {
    if (rowData.PDF) {
      return (
        <Button loading={rowStateFile[rowData.ROW_ID]} icon="pi pi-file-pdf" className="p-button-danger mr-2 p-button-sm text-xs" label='Factura'
          onClick={() => {
            setRowStateFile({ ...rowStateFile, [rowData.ROW_ID]: true });
            generateVoucher(rowData);
          }} />
      )
    } else {
      return <div></div>
    }
  }

  //Tag con estilo segun el estado, en rowData se guarda el {} con todos los datos de la fila
  const statusBodyTemplate = (rowData) => {
    let statusDescription = rowData.STATUS.DESCRIPTION;
    let statusId = rowData.STATUS.ID;

    if (statusId === payStatus.pending && (rowData.STATUS_HIST.ID !== payStatus.pending && rowData.STATUS_HIST.ID !== payStatus.processing)) {
      return <Tag className="mr-2" icon="pi pi-clock" severity="warning" value={statusDescription} rounded></Tag>
    } else if (statusId === payStatus.paid) {
      return <Tag className="mr-2" icon="pi pi-check" severity="success" value={statusDescription} rounded></Tag>
    } else if (statusId === payStatus.declined) {
      return <Tag className="mr-2" icon="pi pi-times" severity="danger" value={statusDescription} rounded></Tag>
    } else if (statusId === payStatus.processing) {
      return <Tag className="mr-2" icon="pi pi-clock" severity="info" value={statusDescription} rounded></Tag>
    } else if (statusId === payStatus.pending && (rowData.STATUS_HIST.ID === payStatus.pending || rowData.STATUS_HIST.ID === payStatus.processing)) {
      return <Tag className="mr-2" icon="pi pi-clock" severity="warning" value="Validando" rounded></Tag>
    }
  }

  //Componente Header donde se encuetra el textLabel para el filtrado global y el boton de limpiar filtro
  const renderHeader1 = () => {
    return (
      <div className="b3">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm " onClick={clearFilter1} />
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm"
            style={{
              width: "100%"
            }}
          />
        </IconField>
      </div>
    )
  }

  //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;
    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  //Limpiar e inicializar los filtros
  const clearFilter1 = () => {
    initFilters1();
  }

  //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
  const header1 = renderHeader1();

  //Limpiar filtros de la tabla
  const initFilters1 = () => {
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'TRANSACTION_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'STATUS': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'PAY_METHOD': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'TRANSACTION_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'TOTAL_VALUE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    });
    setGlobalFilterValue1('');
  }

  const initializeData = (rowData) => {
    setName(rowData.NAME_INVOICE)
    setDescription(rowData.ORDER_DESCRIPTION)
  }

  const clearData = () => {
    setName("")
    setDescription("")
  }

  //Nombre de las opciones para los filtros
  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];

  // Return que entrega la pantalla
  return (
    <div className='mt-6'>
      <div className="surface-100	 px-4 py-5 md:px-6 lg:px-8">
        <Toast ref={toast} />
        <Dialog visible={isOpen} header={"Factura: " + name}
          position="top" draggable={false} resizable={false} modal onHide={hideModal}>
          <div className="product-item">
            <div className="product-detail">
              <div className="product-description">Detalle: {description}</div>
            </div>
            <Base64Downloader style={{ border: "0px", background: "transparent", marginTop: '2rem' }} base64={contenido} downloadName={name} onDownloadSuccess={() => { setLoading2(false); hideModal() }}>
              <Button label='Descargar' icon="pi pi-download" loading={loading2} onClick={() => setLoading2(true)} />
            </Base64Downloader>
          </div>
        </Dialog>
        <div className="flex flex-row align-items-center justify-content-center mb-3 -mt-4 font-bold text-4xl">
          <span className="text-900">Facturación</span>
          <Video header="Instructivo pago facturación" url={localStorage.getItem('PAYORDER_VIDEO')} />
        </div>
        <ul className='text-justify text-sm'>
          <li style={{ listStyleType: 'disc' }}>
            Si no finalizaste tu transacción, intenta nuevamente en 30 minutos.
          </li>
          <li style={{ listStyleType: 'disc' }}>
            Si el estado de tu transacción es <b><i>validando</i></b> y realizaste el pago, recuerda que se puede tomar hasta 30 minutos en ser confirmardo.
          </li>
        </ul>
        <div className="card mt-4">
          <SkeletonTable load={loadPage}>
            <DataTable className="text-xs" value={products} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
              selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)} dataKey="CONTRACT_ID"
              size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['TRANSACTION_ID', 'STATUS', 'PAY_METHOD', 'TOTAL_VALUE', 'TRANSACTION_DATE']}
              header={header1} >
              <Column field="TRANSACTION_ID" header="Id. Transacción" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por transacción" sortable></Column>
              <Column field="ORDER_NAME" header="Servicio" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Servicio" sortable></Column>
              <Column header="Estado" headerStyle={{ width: '8rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={statusBodyTemplate} />
              <Column field="PAY_METHOD" header="Metodo de pago" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Metodo de pago" sortable></Column>
              <Column field="TOTAL_VALUE" header="Total pago" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Total" sortable></Column>
              <Column field="TRANSACTION_DATE" header="Fecha de pago" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha depago" sortable></Column>
              <Column header="Pagos" headerStyle={{ width: '4rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
              <Column header="Factura" headerStyle={{ width: '4rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={invoiceBodyTemplate} />
            </DataTable>
          </SkeletonTable>
        </div>
      </div>
    </div>
  );
} 